/**
 *  RaceSegmentQuad
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
export default class RaceSegmentQuad {
    /**
     * @param {PIXI.Point} [topLeft]
     * @param {PIXI.Point} [topRight]
     * @param {PIXI.Point} [bottomLeft]
     * @param {PIXI.Point} [bottomRight]
     */
    constructor(topLeft, topRight, bottomLeft, bottomRight) {
        /**
         * @member {PIXI.Point}
         */
        this.topLeft = topLeft || new PIXI.Point();

        /**
         * @member {PIXI.Point}
         */
        this.topRight = topRight || new PIXI.Point();

        /**
         * @member {PIXI.Point}
         */
        this.bottomLeft = bottomLeft || new PIXI.Point();

        /**
         * @member {PIXI.Point}
         */
        this.bottomRight = bottomRight || new PIXI.Point();
    }

    /**
     * @returns {RaceSegmentQuad}
     */
    clone() {
        return new RaceSegmentQuad(this.topLeft, this.topRight, this.bottomLeft, this.bottomRight);
    }
}